import { ReactElement } from 'react';
import { Field, useFormikContext } from 'formik';
import { iThirdPartyFormValues } from '@services/ThirdPartyService';
import { ContactInputWithExperian, EmailFieldWithExperian, TextInput } from '@components';
import { FormType } from '@constants/forms';
import gridFormStyles from '@pages/forms/Grid.module.scss';

import styles from './IndividualForm.module.scss';

const IndividualForm = (): ReactElement => {
  const { values }: { values: iThirdPartyFormValues } = useFormikContext();
  return (
    <div className={styles.container}>
      <div className={gridFormStyles.form}>
        <div className={gridFormStyles.gridColFull}>
          <Field name="GivenNames" component={TextInput} title="Given name(s)" isMandatory />
        </div>
        <div className={gridFormStyles.gridColFull}>
          <Field name="FamilyName" component={TextInput} title="Family name" isMandatory />
        </div>
        <Field component={ContactInputWithExperian} name="IndividualContactNumber" title="Contact phone number" isMandatory orientationRow obligationNumber={values.OBLIGATION_NUMBER} formName={FormType.THIRDPARTY} secondaryContact={false} hasPrimaryNumberType={false} warningMessage="IndividualContactNumberWarning" />
        <Field component={EmailFieldWithExperian} name="EmailAddressOptional" title="Email" isMandatory orientationRow obligationNumber={values.OBLIGATION_NUMBER} formName={FormType.THIRDPARTY} noEmailField="NoEmailAddress" currentSP="Select if they do not have an email address" warningMessage="EmailAddressOptionalWarning" />
      </div>
    </div>
  );
};

export default IndividualForm;
